export default __webpack_public_path__ + "static/media/contact.a7d3474d.png";